<template>
  <div class="contract-management-container">
    <!-- 左侧蓝色标记和标题 -->
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">合同管理</h2>
    </div>
    
    <!-- 标签页 -->
    <div class="tabs-container">
      <div class="tabs">
        <div 
          :class="['tab-item', activeTab === 'supplier' ? 'active' : '']" 
          @click="switchTab('supplier')"
        >采购合同管理</div>
        <div 
          :class="['tab-item', activeTab === 'customer' ? 'active' : '']" 
          @click="switchTab('customer')"
        >销售合同管理</div>
      </div>
    </div>
    
    <!-- 搜索区域 - 采购合同 -->
    <div v-if="activeTab === 'supplier'" class="search-area">
      <div class="search-inputs">
        <div class="search-item">
          <el-input
            v-model="searchForm.contract_name"
            placeholder="合同名称"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.supplier_name"
            placeholder="供应商名称"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-select
            v-model="searchForm.status"
            placeholder="状态"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">新增采购合同</el-button>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 - 销售合同 -->
    <div v-if="activeTab === 'customer'" class="search-area">
      <div class="search-inputs">
        <div class="search-item">
          <el-input
            v-model="searchForm.contract_name"
            placeholder="合同名称"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.customer_name"
            placeholder="客户名称"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-select
            v-model="searchForm.status"
            placeholder="状态"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">新增销售合同</el-button>
        </div>
      </div>
    </div>
    
    <!-- 表格区域 - 采购合同 -->
    <div v-if="activeTab === 'supplier'" class="table-container">
      <el-table
        :data="supplierContractData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
      >
        <el-table-column prop="contract_name" label="合同名称" min-width="300"></el-table-column>
        <el-table-column prop="supplier_name" label="供应商名称" min-width="200"></el-table-column>
        <el-table-column prop="status" label="合同状态" width="100"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="120"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <div class="button-group">
              <!-- 根据状态显示不同的操作按钮 -->
            <el-button
                v-if="['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="warning"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
                v-if="['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
            >删除</el-button>
            <el-button
                v-if="!['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="primary"
              @click="handleView(scope.row)"
            >查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    
    <!-- 表格区域 - 销售合同 -->
    <div v-if="activeTab === 'customer'" class="table-container">
      <el-table
        :data="customerContractData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
      >
        <el-table-column prop="contract_name" label="合同名称" min-width="300"></el-table-column>
        <el-table-column prop="customer_name" label="客户名称" min-width="200"></el-table-column>
        <el-table-column prop="status" label="合同状态" width="100"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="120"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <div class="button-group">
              <!-- 根据状态显示不同的操作按钮 -->
            <el-button
                v-if="['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="warning"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
                v-if="['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
            >删除</el-button>
            <el-button
                v-if="!['签订', '0'].includes(scope.row.status)"
              size="mini"
              type="primary"
              @click="handleView(scope.row)"
            >查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    
    <!-- 删除确认对话框 -->
    <el-dialog
      v-dialog-drag
      title="提示"
      :visible.sync="deleteDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="delete-dialog-content">
        <i class="el-icon-warning-outline warning-icon"></i>
        <span>确认删除该合同吗？</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDelete">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'

export default {
  name: 'AdminContracts',
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'supplier',
      // 搜索表单
      searchForm: {
        contract_name: '',
        supplier_name: '',
        customer_name: '',
        status: ''
      },
      // 加载状态
      loading: false,
      // 采购合同数据
      supplierContractData: [],
      // 销售合同数据
      customerContractData: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 删除确认对话框
      deleteDialogVisible: false,
      deleteId: null,
      deleteType: '', // 'supplier' 或 'customer'
      statusOptions: [
        { value: '签订', label: '签订' },
        { value: '执行中', label: '执行中' },
        { value: '决算', label: '决算' },
        { value: '收尾', label: '收尾' },
        { value: '终止', label: '终止' }
      ]
    }
  },
  created() {
// 从URL参数中获取当前标签
    const tab = this.$route.query.tab;
    if (tab && ['supplier', 'customer'].includes(tab)) {
      this.activeTab = tab;
    }
    
    // 初始化加载数据
    this.fetchContractList();
  },
  mounted() {
},
  methods: {
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab;
      this.searchForm = {
        contract_name: '',
        supplier_name: '',
        customer_name: '',
        status: ''
      };
      this.pagination.currentPage = 1;
      
      // 更新URL参数，记住标签状态
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, tab }
      });
      
      this.fetchContractList();
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      
      try {
        return moment(dateString).format('YYYY-MM-DD');
      } catch (error) {
        console.error('日期格式化错误:', error);
        return dateString;
      }
    },
    
    // 获取合同列表数据
    fetchContractList() {
      this.loading = true;
      
      if (this.activeTab === 'supplier') {
        this.fetchSupplierContracts();
      } else {
        this.fetchCustomerContracts();
      }
    },
    
    // 获取采购合同列表
    fetchSupplierContracts() {
      // 构建查询参数
      const params = {
        contract_name: this.searchForm.contract_name,
        status: this.searchForm.status,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      };
      
      // 如果有供应商名称，则作为查询条件
      if (this.searchForm.supplier_name) {
        params.supplier_name = this.searchForm.supplier_name;
      }
      
      // 移除空值参数
      Object.keys(params).forEach(key => {
        if (!params[key] && params[key] !== 0) {
          delete params[key];
        }
      });
      
      // 调用API获取采购合同列表
      api.contract.getSupplierContractList(params)
        .then(response => {
if (response.data && response.data.success) {
            const { data, total } = response.data.data;
            
            // 处理返回数据
            this.supplierContractData = data.map(item => {
              // 不再转换状态，直接使用原始状态
              return {
                ...item,
                create_time: this.formatDate(item.create_time)
              };
            });
            
            this.pagination.total = total;
            
          } else {
            this.$message.error(response.data.message || '获取采购合同列表失败');
            this.supplierContractData = [];
          }
        })
        .catch(error => {
          console.error('获取采购合同列表失败:', error);
          this.$message.error('获取采购合同列表失败，请稍后重试');
          this.supplierContractData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 获取销售合同列表
    fetchCustomerContracts() {
      // 构建查询参数
      const params = {
        contract_name: this.searchForm.contract_name,
        customer_name: this.searchForm.customer_name,
        status: this.searchForm.status,
        current: this.pagination.currentPage,  // 注意销售合同API使用current而不是page
        pageSize: this.pagination.pageSize
      };
      
      // 移除空值参数
      Object.keys(params).forEach(key => {
        if (!params[key] && params[key] !== 0) {
          delete params[key];
        }
      });
      
      // 调用API获取销售合同列表
      api.contract.getCustomerContractList(params)
        .then(response => {
if (response.data && response.data.success) {
            const { data, total, current, pageSize } = response.data.data;
            
            // 处理返回数据
            this.customerContractData = data.map(item => {
              // 获取所有客户项目中的客户名称并组合
              let customerNames = [];
              
              if (item.customerProjects && item.customerProjects.length > 0) {
                // 遍历所有客户项目，收集客户名称
                customerNames = item.customerProjects.map(project => {
                  if (project.Customer && project.Customer.unit_name) {
                    return project.Customer.unit_name;
                  } else if (project.customer_name) {
                    return project.customer_name;
                  }
                  return null;
                }).filter(name => name); // 过滤掉null值
              }
              
              // 组合所有客户名称，如果没有则显示未知客户
              const customer_name = customerNames.length > 0 
                ? customerNames.join(', ') 
                : '未知客户';
              
              // 不再转换状态，直接使用原始状态
              return {
                ...item,
                create_time: this.formatDate(item.create_time),
                customer_name: customer_name
              };
            });
            
            this.pagination.total = total;
            this.pagination.currentPage = current;
            this.pagination.pageSize = pageSize;
            
          } else {
            this.$message.error(response.data.message || '获取销售合同列表失败');
            this.customerContractData = [];
          }
        })
        .catch(error => {
          console.error('获取销售合同列表失败:', error);
          this.$message.error('获取销售合同列表失败，请稍后重试');
          this.customerContractData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 搜索方法
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchContractList();
    },
    
    // 显示新增对话框
    showAddDialog() {
      if (this.activeTab === 'supplier') {
        this.$router.push('/contracts/supplier/create');
      } else {
        this.$router.push('/contracts/customer/create');
      }
    },
    
    // 编辑操作
    handleEdit(row) {
      if (this.activeTab === 'supplier') {
        this.$router.push(`/contracts/supplier/edit/${row.id}`);
      } else {
        this.$router.push(`/contracts/customer/edit/${row.id}`);
      }
    },
    
    // 查看操作
    handleView(row) {
      if (this.activeTab === 'supplier') {
        this.$router.push(`/contracts/supplier/view/${row.id}`);
      } else {
        this.$router.push(`/contracts/customer/view/${row.id}`);
      }
    },
    
    // 删除操作
    handleDelete(row) {
      this.deleteDialogVisible = true;
      this.deleteId = row.id;
      this.deleteType = this.activeTab === 'supplier' ? 'supplier' : 'customer';
    },
    
    // 确认删除
    confirmDelete() {
      this.loading = true;
      const params = {
        id: this.deleteId,
        type: this.deleteType
      };
      
      api.contract.deleteContract(params)
        .then(response => {
if (response.data && response.data.success) {
            this.$message.success('合同删除成功');
            this.fetchContractList();
        } else {
            this.$message.error(response.data.message || '合同删除失败');
          }
        })
        .catch(error => {
          console.error('合同删除失败:', error);
          this.$message.error('合同删除失败，请稍后重试');
        })
        .finally(() => {
        this.deleteDialogVisible = false;
        this.loading = false;
        });
    },
    
    // 处理分页变化
    handleSizeChange(newSize) {
      this.pagination.pageSize = newSize;
      this.fetchContractList();
    },
    
    // 处理当前页变化
    handleCurrentChange(newPage) {
      this.pagination.currentPage = newPage;
      this.fetchContractList();
    }
  }
}
</script>

<style scoped>
  /* 添加一些自定义样式 */
.contract-management-container {
  padding: 20px;
  }
  
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
    
    .blue-bar {
    width: 4px;
    height: 20px;
    background-color: #409EFF;
      margin-right: 8px;
    }
    
    .page-title {
    font-size: 18px;
    font-weight: bold;
      margin: 0;
  }
  
  .tabs-container {
    margin-bottom: 20px;
  }
    
    .tabs {
      display: flex;
    border-bottom: 1px solid #DCDFE6;
  }
      
      .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    margin-right: 20px;
        font-size: 14px;
  }

  .active {
    color: #409EFF;
    border-bottom: 2px solid #409EFF;
  }
  
  .search-area {
    background-color: #F5F7FA;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
  }
    
    .search-inputs {
      display: flex;
      flex-wrap: wrap;
    align-items: center;
  }
      
      .search-item {
        margin-right: 15px;
        margin-bottom: 10px;
        width: 200px;
      }
      
      .search-buttons {
        display: flex;
    margin-left: auto;
  }

  .search-buttons .el-button {
    margin-left: 10px;
  }
  
  .table-container {
      margin-bottom: 20px;
  }
  
  .pagination-container {
    text-align: right;
    margin-top: 20px;
  }
  
  .delete-dialog-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
  }
    
    .warning-icon {
    color: #E6A23C;
      font-size: 24px;
      margin-right: 10px;
    }
    
  .edit-btn {
    color: #409EFF;
    }

  .delete-btn {
    color: #F56C6C;
  }

  .view-btn {
    color: #67C23A;
}
</style> 